// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"ac1747e3","197":"98fb3df8","453":"c9fa93a2"}[chunkId] + ".chunk.js";
};